import React from 'react';
import './SelectedCandidatesTab.css';
import UserAvatar from 'react-user-avatar';
import Tabs from '../../../UI/Tabs/Tabs';
import Tab from '../../../UI/Tab/Tab';
import Icon from '../../../UI/Icon/Icon'; 
import moment from 'moment';
import ConsoleLog from './../../../../hoc/ConsoleLog/ConsoleLog';

const Initials = (props) => {
  const initialColor=['#E0E9F2', '#C9EDE6', '#C4CAD0', '#F4ADAE', '#E9D7D8', '#EAC0CE'];

	return ( <UserAvatar className="UserAvatar-light" name={props.initials?props.initials:'--'} colors={initialColor}/> );
}

const SelectedCandidatesTab = (props) => {
    const ScheduledCount = props.candidates&&props.candidates.filter((candidate)=>candidate.candidate_status==="Accepted").length;
    const PendingCount = props.candidates&&props.candidates.filter((candidate)=>candidate.candidate_status==="Pending").length;
    const RejectedCount = props.candidates&&props.candidates.filter((candidate)=>candidate.candidate_status==="Rejected").length;

    return(
    <div className="client-interview-view-tabs">
      <h4>Candidates selected for interview</h4>
      {props.candidates ?
      <div className="candidates-selected-tabs">
            <Tabs>
            <Tab label={"Scheduled ("+ScheduledCount+")"} tabKey={1} onClickHandler={()=>null}>
              <div className="scheduled-section">
                <div>
                <ul>
                  {props.candidates ? props.candidates.filter((candidate)=>candidate.candidate_status==="Accepted").map((candidate) => {
                    const image = candidate.s3SignedUrl?<img src={candidate.s3SignedUrl}/>:<Initials initials={candidate.initials} />                   
                    let durationArray = props.duration&&props.duration.split(" ");
                    ConsoleLog("durationArray",durationArray)
                    const time=  props.duration&&props.duration === "30 mins"?
                        moment.utc(candidate.candidate_slot).format('hh:mma') + " - " + moment.utc(candidate.candidate_slot).add(30, 'minutes').format('hh:mma')
                        :
                        moment.utc(candidate.candidate_slot).format('hh:mma')+ " - " + moment.utc(candidate.candidate_slot).add(durationArray[0], 'hours').format('hh:mma');                        
                    return(
                        <li>
                            {image}
                            <span>{candidate.candidate_fname+ " "+ candidate.candidate_lname}</span>
                            <Icon icon="scheduled-tab-icon"/>
                            <div className="scheduled-date-time">
                            <span>{time}</span>
                            {moment(candidate.candidate_slot).format('D MMMM YYYY')}
                            </div>
                        </li>
                    )
                    }): ""}
                </ul>
                </div>
              </div>
            </Tab>
            <Tab label={"Pending ("+PendingCount+")"} tabKey={2} onClickHandler={()=>null}>
              <div className="pending-section">
              <div>
              <ul>
                {props.candidates ? props.candidates.filter((candidate)=>candidate.candidate_status==="Pending").map((candidate) => {
                ConsoleLog("initials",candidate.initials);                
                const image = candidate.s3SignedUrl?<img src={candidate.s3SignedUrl}/>:<Initials initials={candidate.initials} />
                return(
                    <li>
                      {image}
                      <span>{candidate.candidate_fname+ " "+ candidate.candidate_lname}</span>
                      <Icon icon="pending-tab-icon"/>
                    </li>
                )
                }): ""}
             </ul>
              </div>
              </div>
            </Tab>
             <Tab label={"Rejected ("+RejectedCount+")"} tabKey={3} onClickHandler={()=>null}>
              <div className="reject-section">
              <div>
              <ul>
                {props.candidates? props.candidates.filter((candidate)=>candidate.candidate_status==="Rejected").map((candidate) => {
                const image = candidate.s3SignedUrl?<img src={candidate.s3SignedUrl}/>:<Initials initials={candidate.initials} />
                return(
                    <li>
                      {image}
                      <span>{candidate.candidate_fname+ " "+ candidate.candidate_lname}</span>
                      <Icon icon="decline-tab-icon"/>
                    </li>
                )
                }): ""}
             </ul>
              </div>
              </div>
            </Tab>
            
          </Tabs>
     </div>   :""}
     
    </div>
  );
}
export default SelectedCandidatesTab;


// WEBPACK FOOTER //
// ./src/components/Client/ClientInterviewSchedular/SelectedCandidatesTab/SelectedCandidatesTab.js